// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"9fd551e2","513":"d0f7001b","703":"d6fe9a46"}[chunkId] + ".chunk.js";
};